import React, { useEffect, useState } from 'react';
import './WhoWeAre.css';

const WhoWeAre = () => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      // Multiply scrollY by a factor to control rotation speed
      setRotation(scrollY * 0.15);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section
      className="who-we-are"
      id="about"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
      }}
    >
      <div className="who-we-are__container">
        {/* Left Column: Overlapping Images */}
        <div className="who-we-are__images-wrapper">
          {/* Rotating Stamp */}
          <div
            className="who-we-are__stamp"
            style={{ transform: `rotate(${rotation}deg)` }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/G-3.webp`}
              alt="Certified Quran Academy Stamp"
              className="who-we-are__stamp-img"
            />
          </div>

          {/* Top Image */}
          <div className="who-we-are__img-container who-we-are__img-container--top">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/BG-3.jpg`}
              alt="Online Quran Classes For Kids"
              className="who-we-are__main-img"
            />
          </div>

          {/* Bottom Image */}
          <div className="who-we-are__img-container who-we-are__img-container--bottom">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/wmremove-transformed-2.jpeg`}
              alt="Online Quran Classes For Kids"
              className="who-we-are__main-img"
            />
          </div>
        </div>

        {/* Right Column: Text & Content */}
        <div className="who-we-are__content">
          <h3 className="who-we-are__subtitle">
            <svg aria-hidden="true" className="who-we-are__subtitle-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span>Who We Are?</span>
          </h3>

          <h2 className="who-we-are__title">
            More Than a Tutor: An Online Quran Academy Built Around You
          </h2>

          <p className="who-we-are__paragraph">
            There's a real difference between a platform that lists teachers and an academy that trains them. We're proud to be the second. Every <a style={{ color: '#006100', textDecoration: 'none' }} href="https://alquranlesson.com/our-tutors/">tutor</a> at Al Quran Lesson is certified, U.S born, university-educated, and has been specifically prepared to teach the Quran in a one-on-one, online setting, not simply pulled from a freelance directory and handed a login.
          </p>

          <p className="who-we-are__paragraph">
            Our online Quran classes are private. No group calls, no split attention. Every lesson plan is shaped around the person learning it, whether that's a five-year-old sounding out their first letters or an adult returning to the Quran after years away.
          </p>

          <p className="who-we-are__paragraph">
            We've built our teaching around the standards of traditional Islamic scholarship, delivered through live video in a way that actually fits modern family life. That combination is a big part of why so many parents searching for the best online Quran academy in the USA end up staying with us for years rather than switching around. We also have male or female tutors, and we schedule around every U.S. and Canadian time zone. Each student also gets a personal learning plan, regular progress updates, and a certificate once they complete their course.
          </p>

          <ul className="who-we-are__list">
            <li className="who-we-are__list-item">
              <span className="who-we-are__list-bullet"></span>
              Certified, native Arabic-speaking tutors
            </li>
            <li className="who-we-are__list-item">
              <span className="who-we-are__list-bullet"></span>
              Available around the clock, in every U.S. and Canadian time zone
            </li>
            <li className="who-we-are__list-item">
              <span className="who-we-are__list-bullet"></span>
              A completion certificate for every course
            </li>
          </ul>

          <div className="who-we-are__contacts">
            <a href="tel:+17164577657" className="who-we-are__contact-item">
              <div className="who-we-are__contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="who-we-are__contact-svg">
                  <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                </svg>
              </div>
              <div className="who-we-are__contact-text">
                <span className="who-we-are__contact-label">Call Us Anytime</span>
                <span className="who-we-are__contact-value">(716) 457-7657</span>
              </div>
            </a>

            <a href="mailto:info@alquranlesson.com" className="who-we-are__contact-item">
              <div className="who-we-are__contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="who-we-are__contact-svg">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </div>
              <div className="who-we-are__contact-text">
                <span className="who-we-are__contact-label">Email Us Anytime</span>
                <span className="who-we-are__contact-value">info@alquranlesson.com</span>
              </div>
            </a>
          </div>

          <a href="/free-trial/" className="who-we-are__btn" style={{ textDecoration: 'none' }}>
            Book Your 3-Day Free Trial
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="who-we-are__btn-icon">
              <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
